export type PersistedCustomerFilters = {
  search: string
  platform_ids: string[]
  billing_plan_id: string
  is_active: string
  source: string
  from_date: string
  to_date: string
  sync_from_date: string
  sync_to_date: string
}

export const DEFAULT_PERSISTED_CUSTOMER_FILTERS: PersistedCustomerFilters = {
  search: '',
  platform_ids: [],
  billing_plan_id: '',
  is_active: '',
  source: '',
  from_date: '',
  to_date: '',
  sync_from_date: '',
  sync_to_date: '',
}

const STORAGE_KEY_PREFIX = 'manage-customers-filters'

export const getCustomerFiltersStorageKey = (userId?: number | string | null) => {
  if (userId === undefined || userId === null || userId === '') {
    return null
  }

  return `${STORAGE_KEY_PREFIX}-${userId}`
}

export const loadPersistedCustomerFilters = (
  userId?: number | string | null
): PersistedCustomerFilters | null => {
  const storageKey = getCustomerFiltersStorageKey(userId)
  if (!storageKey) {
    return null
  }

  try {
    const savedFilters = localStorage.getItem(storageKey)
    if (!savedFilters) {
      return null
    }

    const parsed = JSON.parse(savedFilters) as Partial<PersistedCustomerFilters>

    return {
      search: parsed.search ?? '',
      platform_ids: Array.isArray(parsed.platform_ids)
        ? parsed.platform_ids.map(String)
        : [],
      billing_plan_id: parsed.billing_plan_id ?? '',
      is_active: parsed.is_active ?? '',
      source: parsed.source ?? '',
      from_date: parsed.from_date ?? '',
      to_date: parsed.to_date ?? '',
      sync_from_date: parsed.sync_from_date ?? '',
      sync_to_date: parsed.sync_to_date ?? '',
    }
  } catch (error) {
    console.error('Error loading persisted customer filters:', error)
    return null
  }
}

export const savePersistedCustomerFilters = (
  userId: number | string | null | undefined,
  filters: PersistedCustomerFilters
) => {
  const storageKey = getCustomerFiltersStorageKey(userId)
  if (!storageKey) {
    return
  }

  localStorage.setItem(storageKey, JSON.stringify(filters))
}

export const clearPersistedCustomerFilters = (userId?: number | string | null) => {
  const storageKey = getCustomerFiltersStorageKey(userId)
  if (!storageKey) {
    return
  }

  localStorage.removeItem(storageKey)
}
